(function () {
  'use strict';

  var SEEN_KEY = 'kotaro_coupon_seen_at';
  var DONE_KEY = 'kotaro_coupon_subscribed';
  // Set once the coupon is revealed, cleared only when the customer closes the
  // success view. While set, a page reload re-opens the coupon so the code is
  // never lost before it's copied.
  var PENDING_KEY = 'kotaro_coupon_pending';
  var DAY_MS = 24 * 60 * 60 * 1000;

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* private mode / storage disabled — fail silently */
    }
  }

  function storageRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      /* fail silently */
    }
  }

  function init(root) {
    if (!root || root.dataset.couponBound === 'true') return;
    root.dataset.couponBound = 'true';

    var designMode = window.Shopify && window.Shopify.designMode;
    var enabled = root.dataset.enabled === 'true';
    var delaySec = parseInt(root.dataset.delay, 10);
    if (isNaN(delaySec)) delaySec = 5;
    var suppressDays = parseInt(root.dataset.suppressDays, 10);
    if (isNaN(suppressDays)) suppressDays = 14;

    var lastFocused = null;
    var openTimer = null;
    var exitBound = false;
    // Force-show for testing/preview: add ?coupon=1 (or ?coupon=show) to the URL.
    var forced = /[?&]coupon=(1|show|preview|test)/i.test(window.location.search);

    function open() {
      if (root.classList.contains('is-open')) return;
      lastFocused = document.activeElement;
      root.hidden = false;
      // next frame so the transition runs
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.body.classList.add('kotaro-coupon-open');
      if (!designMode && !forced) storageSet(SEEN_KEY, String(Date.now()));
      var email = root.querySelector('[data-coupon-email]');
      var firstSuccess = root.querySelector('.kotaro-coupon__copy');
      if (email && !root.classList.contains('is-success')) {
        try { email.focus({ preventScroll: true }); } catch (e) { email.focus(); }
      } else if (firstSuccess) {
        try { firstSuccess.focus({ preventScroll: true }); } catch (e) {}
      }
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      // Closing the success view is intentional — stop restoring the coupon.
      if (root.classList.contains('is-success')) storageRemove(PENDING_KEY);
      root.classList.remove('is-open');
      document.body.classList.remove('kotaro-coupon-open');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 450);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    // Gate closing so the coupon can't be dismissed by accident. In the success
    // view, backdrop clicks are ignored and the × asks for confirmation.
    function requestClose(viaBackdrop) {
      if (root.classList.contains('is-success')) {
        if (viaBackdrop) return;
        var msg = root.getAttribute('data-close-confirm') ||
          'クーポンコードはコピーしましたか？\nこの画面を閉じると、コードは再表示されません。';
        if (!window.confirm(msg)) return;
      }
      close();
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) requestClose(false);
    }

    // Close triggers: the backdrop overlay vs. the explicit × button.
    root.querySelectorAll('[data-coupon-close]').forEach(function (el) {
      var viaBackdrop = el.classList.contains('kotaro-coupon__overlay');
      el.addEventListener('click', function () {
        requestClose(viaBackdrop);
      });
    });

    // ---- Form submission (AJAX to Shopify /contact) ----
    var form = root.querySelector('form');
    var submitBtn = root.querySelector('[data-coupon-submit]');

    // Reveal the coupon. Called whether the email request succeeds or fails,
    // so a network hiccup never blocks the customer from their coupon.
    function revealCoupon() {
      storageSet(DONE_KEY, 'true');
      storageSet(PENDING_KEY, 'true');
      root.classList.remove('has-error');
      root.classList.add('is-success');
      var copyBtn = root.querySelector('[data-coupon-copy]');
      if (copyBtn) {
        try { copyBtn.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        root.classList.remove('has-error');
        if (submitBtn) submitBtn.disabled = true;
        var data = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: data,
          headers: { Accept: 'application/json' }
        })
          .then(revealCoupon)
          .catch(revealCoupon)
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
        return false;
      });
    }

    // ---- Copy coupon code ----
    var copyBtn = root.querySelector('[data-coupon-copy]');
    var codeEl = root.querySelector('[data-coupon-code]');
    if (copyBtn && codeEl) {
      var script = document.currentScript;
      var copiedLabel = 'コピーしました';
      var scriptTag = document.querySelector('script[data-coupon-copied]');
      if (scriptTag) copiedLabel = scriptTag.getAttribute('data-coupon-copied') || copiedLabel;
      var originalLabel = copyBtn.textContent.trim();

      copyBtn.addEventListener('click', function () {
        var code = codeEl.textContent.trim();
        var done = function () {
          copyBtn.textContent = copiedLabel;
          window.setTimeout(function () {
            copyBtn.textContent = originalLabel;
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {
            legacyCopy(code, done);
          });
        } else {
          legacyCopy(code, done);
        }
      });
    }

    function legacyCopy(text, cb) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      if (cb) cb();
    }

    // ---- Exit-intent (optional, desktop) ----
    function bindExitIntent() {
      if (exitBound) return;
      exitBound = true;
      document.addEventListener('mouseout', onMouseOut);
    }
    function onMouseOut(e) {
      if (e.clientY <= 0 && !e.relatedTarget) {
        document.removeEventListener('mouseout', onMouseOut);
        open();
      }
    }

    // ---- Decide whether to auto-open ----
    function shouldShow() {
      if (!enabled) return false;
      if (storageGet(DONE_KEY) === 'true') return false;
      var seenAt = parseInt(storageGet(SEEN_KEY), 10);
      if (!isNaN(seenAt)) {
        var elapsed = Date.now() - seenAt;
        if (elapsed < suppressDays * DAY_MS) return false;
      }
      return true;
    }

    // Theme editor: show on select, hide on deselect — no timers, no storage
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.target === root.closest('.shopify-section')) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target === root.closest('.shopify-section')) close();
      });
      return;
    }

    if (storageGet(PENDING_KEY) === 'true') {
      // Coupon was revealed but not yet closed (e.g. a reload happened before
      // it was copied) — restore the success view so the code isn't lost.
      root.classList.add('is-success');
      openTimer = window.setTimeout(open, 300);
    } else if (forced) {
      // Testing/preview: ignore "enabled", storage suppression and the delay.
      openTimer = window.setTimeout(open, 300);
    } else if (shouldShow()) {
      openTimer = window.setTimeout(open, delaySec * 1000);
    }
  }

  function boot() {
    document.querySelectorAll('[data-kotaro-coupon]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
